import React from 'react';
import { Gesture } from '@mui/icons-material';
import { RichContent } from "@gisce/oficina-virtual-components";
import { useTranslation } from 'react-i18next';

const SignatureProcess = ({icon = <Gesture/>}) => {

  const { t } = useTranslation();
  return (
    <div>
      {icon}
      <span style={{marginLeft: '10px'}}>
        <RichContent content={t('common:text.contracts_signature_process')} />
      </span>
    </div>
  );
};

export default SignatureProcess;
